export const PLATFORM_PER_MONTH = 199;
export const PRICING_PAGE = "https://www.teamable.com/contact";
